export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48')
];

export const server_loads = [];

export const dictionary = {
		"/": [13],
		"/account": [18],
		"/account/verify-email": [19],
		"/admin": [20,[3]],
		"/admin/blacklist-hits": [29,[3,6]],
		"/admin/invites": [30,[3]],
		"/admin/settings": [31,[3]],
		"/admin/speakers": [32,[3,7]],
		"/admin/speakers/new": [35,[3,7]],
		"/admin/speakers/[speaker_tag]": [33,[3,7,8]],
		"/admin/speakers/[speaker_tag]/edit": [34,[3,7,8]],
		"/admin/stats": [36,[3,9]],
		"/admin/stats/[stream_tag]": [37,[3,9]],
		"/admin/streams": [38,[3,10]],
		"/admin/streams/new": [42,[3,10]],
		"/admin/streams/[stream_tag]": [39,[3,10,11]],
		"/admin/streams/[stream_tag]/edit": [40,[3,10,11]],
		"/admin/streams/[stream_tag]/refresh": [41,[3,10,11]],
		"/admin/[tag]": [21,[3,4]],
		"/admin/[tag]/moderation": [22,[3,4]],
		"/admin/[tag]/overlay": [23,[5]],
		"/admin/[tag]/panel": [24,[3,4]],
		"/admin/[tag]/settings": [25,[3,4]],
		"/admin/[tag]/verify-email": [26,[3,4]],
		"/admin/[tag]/voices/new": [28,[3,4]],
		"/admin/[tag]/voices/[voice_tag]": [27,[3,4]],
		"/leaderboard": [43],
		"/onboard": [44,[12]],
		"/privacy": [45],
		"/signin": [46],
		"/submission": [47],
		"/terms": [48],
		"/[tag]": [14,[2]],
		"/[tag]/image": [15,[2]],
		"/[tag]/text": [16,[2]],
		"/[tag]/voice": [17,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';